import { useState } from "react";
import { Menu, X, ShoppingBag, Phone } from "lucide-react";
import { BRAND } from "@/data/products";
import { useCart } from "@/context/CartContext";
import { waLink } from "@/lib/whatsapp";
import { trackWhatsAppClick } from "@/lib/analytics";
import { NAV } from "@/constants/testIds";

const links = [
  { id: "catalogo", label: "Catálogo", testId: NAV.catalog },
  { id: "zona-sul", label: "Zona Sul", testId: "nav-link-zona-sul" },
  { id: "como-funciona", label: "Como funciona", testId: NAV.how },
  { id: "cobertura", label: "Cobertura", testId: "nav-link-cobertura" },
  { id: "faq", label: "Dúvidas", testId: NAV.faq },
  { id: "contato", label: "Contato", testId: NAV.contact },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { setIsOpen, count } = useCart();

  return (
    <header className="sticky top-0 z-40 bg-[#F9F8F6]/80 backdrop-blur-xl border-b border-[#E5E3DB]">
      <div className="container-wide flex items-center justify-between h-16 md:h-20">
        <a href="#top" data-testid={NAV.brand} className="flex items-center gap-2 group">
          <span className="font-serif text-xl md:text-2xl tracking-tight text-[#2D4A3E] leading-none">Central de Coroas</span>
          <span className="hidden sm:inline text-[10px] tracking-[0.25em] uppercase text-[#BFA573] mt-1.5">de Flores RJ</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`} data-testid={l.testId}
               className="text-sm text-[#1C1C1C] hover:text-[#2D4A3E] transition-colors duration-300">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a href={`tel:+${BRAND.phoneE164}`}
             className="hidden lg:inline-flex items-center gap-2 text-sm text-[#2D4A3E] hover:text-[#1F352B]">
            <Phone className="h-4 w-4" strokeWidth={1.5} /> {BRAND.phoneDisplay}
          </a>

          <button data-testid={NAV.cartBtn} onClick={() => setIsOpen(true)}
                  className="relative inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#E5E3DB] hover:border-[#2D4A3E] transition-colors">
            <ShoppingBag className="h-4 w-4 text-[#2D4A3E]" strokeWidth={1.5} />
            {count > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#2D4A3E] text-white text-[10px] h-5 min-w-[20px] rounded-full flex items-center justify-center px-1 font-medium">
                {count}
              </span>
            )}
          </button>

          <a href={waLink("Olá, gostaria de tirar uma dúvida sobre as coroas de flores.")}
             target="_blank" rel="noreferrer"
             onClick={() => trackWhatsAppClick("nav_header")}
             data-testid={NAV.whatsapp}
             className="hidden sm:inline-flex btn-whatsapp px-4 py-2 text-sm">
            WhatsApp
          </a>

          <button onClick={() => setOpen(!open)}
                  className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-[#E5E3DB]"
                  aria-label="menu" data-testid="mobile-menu-toggle">
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E5E3DB] bg-white">
          <div className="container-wide py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.id} href={`#${l.id}`} onClick={() => setOpen(false)}
                 className="py-2 text-sm text-[#1C1C1C] border-b border-[#E5E3DB] last:border-b-0">
                {l.label}
              </a>
            ))}
            <a href={`tel:+${BRAND.phoneE164}`} className="py-2 text-sm text-[#2D4A3E]">
              {BRAND.phoneDisplay}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
